import { makeVar } from '@apollo/client';
import i18next from 'i18next';

export const getInitialData = () => ({
  open: false,
  callback: () => {},
  options: {
    title: i18next.t('Confirm'),
    content: i18next.t('Proceed')
  }
});

const confirmDialogVar = makeVar(getInitialData());

export default confirmDialogVar;
